/**
 * 商品説明エリア: 連続する <br> を最大2本までに圧縮
 * (CSS の隣接兄弟セレクタでは実現できないため JS で対応)
 */
(function() {
  'use strict';

  function compressBrs(container) {
    if (!container) return;

    // 直接の子要素または span などで囲まれた <br> を含めて全取得
    // 同じレベルで連続している <br> だけを処理対象に
    const allChildren = Array.from(container.childNodes);
    let consecutiveBrCount = 0;
    const toRemove = [];

    allChildren.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
        consecutiveBrCount++;
        // 3本目以降は削除対象に
        if (consecutiveBrCount > 2) {
          toRemove.push(node);
        }
      } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '') {
        // 空白テキストノードはスキップ(連続カウントを継続)
        return;
      } else {
        // テキスト or 他要素が出たら連続カウントをリセット
        consecutiveBrCount = 0;
      }
    });

    toRemove.forEach((br) => br.remove());
  }

  function init() {
    const descriptions = document.querySelectorAll('.product__description-content');
    descriptions.forEach(compressBrs);
  }

  // 初期実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // バリアント切替後の再実行: product-info の DOM 差し替えに対応
  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      // product-info 内の description が更新された可能性
      init();
    });

    document.querySelectorAll('product-info').forEach((pi) => {
      observer.observe(pi, { childList: true, subtree: true });
    });
  });
})();